/*
 *   File : edit-phone.js
 *   Author : https://evoqins.com
 *   Description : Edit phone modal component
 *   Integrations : react-toastify
 *   Version : 1.0.0
*/


import React, { memo } from "react";

//Assets
import CloseBtn from "../../Assets/Images/close-btn.svg";
import { PrimaryButton } from "../Buttons";

function DocumentPreviewModal(props) {

    return (
        <div className="modal fade e-manage-modal"
            id="document-preview"
            data-bs-backdrop="static"
            tabIndex="-1"
            aria-labelledby="EditPhoneModal"
            aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div className="modal-content e-bg-lotion e-border-radius-24 e-addbank-box-shadow">
                    <div className="modal-header border-0 justify-content-between p-3 p-sm-4 ">
                        <h1 className="e-font-16-res mb-0 e-text-charleston-green e-font-18 e-alt-font-poppins e-font-weight-600 line-height-32px">
                            Preview document
                        </h1>
                        <img src={CloseBtn}

                            id='document-preview-close-btn'
                            draggable={false}
                            className='cursor-pointer width-24px-res'
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            alt='close'
                            onClick={props.onCloseModal}
                        />
                    </div>

                    {/* Body */}
                    <div className="modal-body px-3 px-sm-4 pt-0 pb-3 pb-sm-4 ">
                        <div className="e-bg-cultured e-border-radius-16 p-3 p-sm-4 mb-sm-4 mb-3 text-center">
                            <img src={props.file} className="img-fluid" alt="document" draggable="false" />
                        </div>
                        <PrimaryButton name="Ok"
                            dismiss={'modal'}
                            className="padding-14px-tb flex-fill w-100 padding-8px-all-res"
                            onPress={props.onCloseModal} />
                    </div>
                </div>
            </div>
        </div >
    )
};

export default memo(DocumentPreviewModal);